import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import SnippetsOutlinedSvg from "@ant-design/icons-svg/es/asn/SnippetsOutlined";
import AntdIcon from "../components/AntdIcon";
var SnippetsOutlined = function SnippetsOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SnippetsOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  SnippetsOutlined.displayName = 'SnippetsOutlined';
}
export default /*#__PURE__*/React.forwardRef(SnippetsOutlined);